// extracted by mini-css-extract-plugin
export default {"add_new_composition_rows":"AddNewCompositionRows_add_new_composition_rows__gFiqr"};